import { render, staticRenderFns } from "./MyFolders.vue?vue&type=template&id=5aee076f&scoped=true"
import script from "./MyFolders.vue?vue&type=script&lang=js"
export * from "./MyFolders.vue?vue&type=script&lang=js"
import style0 from "./MyFolders.vue?vue&type=style&index=0&id=5aee076f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aee076f",
  null
  
)

export default component.exports